module.exports = __webpack_public_path__ + "img/icon-minus-circle.3f9551d0.svg";